import {
  useEffect,
  useRef,
  useState,
} from "react";

export default function useInViewOnce({
  threshold = 0.12,
  rootMargin = "0px 0px -60px 0px",
} = {}) {
  const ref = useRef(null);

  const [isVisible, setIsVisible] =
    useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element || isVisible) {
      return undefined;
    }

    if (
      typeof IntersectionObserver ===
      "undefined"
    ) {
      setIsVisible(true);
      return undefined;
    }

    const observer =
      new IntersectionObserver(
        ([entry]) => {
          if (
            entry.isIntersecting
          ) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        {
          threshold,
          rootMargin,
        },
      );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [
    isVisible,
    rootMargin,
    threshold,
  ]);

  return {
    ref,
    isVisible,
  };
}